var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slots-list',{attrs:{"item-key":"id","headers":_vm.headers,"slots":_vm.slots,"loading":_vm.loading,"loading-text":"Đang Tải"},on:{"change":_vm.onDateChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }